// @flow

import * as React from 'react';
import { Button, ThemeContext } from 'grommet';
import { pathTemplate } from 'speed-js-core';
import { RoutedButton } from 'speed-js-react-web';

type Props = {
    to: string,
    target: string,
    icon: React.Node,
    row: Object,
    routed: boolean,
}

const LinkComponent = (props: Props) => {
    const {
        to: _to, icon, routed, target,
    } = props;

    const to = pathTemplate(_to, props.row._original);

    if (routed) {
        return (
            <RoutedButton icon={icon} to={to} plain={false} />
        );
    }

    return (
        <Button icon={icon} href={to} target={target} />
    );
};

LinkComponent.defaultProps = {
    routed: true,
};

export default LinkComponent;
